// import React, { useContext, createContext, useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { useLocation, useNavigate, Link } from 'react-router-dom';
// import { Box } from '@mui/material';

// const NavigationContext = createContext({
//   previousPath: null,
//   currentPath: null,
//   navDirection: null,
//   setNavDirection: () => {},
//   navigationMap: {},
// });

// // This component will wrap your entire Routes component
// export const NavigationProvider = ({ children, navigationMap = {} }) => {
//   const location = useLocation();
//   const [previousPath, setPreviousPath] = useState(null);
//   const [currentPath, setCurrentPath] = useState(location.pathname);
//   const [navDirection, setNavDirection] = useState(null); // 'up', 'down', or null

//   useEffect(() => {
//     if (location.pathname !== currentPath) {
//       setPreviousPath(currentPath);
//       setCurrentPath(location.pathname);
      
//       // Reset direction after navigation is complete
//       const timer = setTimeout(() => {
//         setNavDirection(null);
//       }, 1000); // Give more time for animation to complete
      
//       return () => clearTimeout(timer);
//     }
//   }, [location.pathname, currentPath]);

//   const determineDefaultDirection = (prev, current) => {
//     if (!prev) return null;
    
//     // Get paths without query params for comparison
//     const cleanPrev = prev.split('?')[0];
//     const cleanCurrent = current.split('?')[0];
    
//     return cleanPrev.localeCompare(cleanCurrent) < 0 ? 'up' : 'down';
//   };

//   return (
//     <NavigationContext.Provider
//       value={{
//         previousPath,
//         currentPath,
//         navDirection,
//         setNavDirection,
//         navigationMap,
//         determineDefaultDirection
//       }}
//     >
//       {children}
//     </NavigationContext.Provider>
//   );
// };

// // Hook to use the navigation context
// export const useNavigation = () => useContext(NavigationContext);

// // This component wraps each Route and applies the animations
// const PageTransitionWrapper = ({ children }) => {
//   const location = useLocation();
//   const { 
//     navDirection, 
//     navigationMap, 
//     previousPath, 
//     determineDefaultDirection 
//   } = useNavigation();
  
//   // Determine direction based on navigation map or default logic
//   const direction = navDirection || 
//     (previousPath && navigationMap[previousPath]?.[location.pathname]) || 
//     determineDefaultDirection(previousPath, location.pathname) || 
//     'up'; // Default to 'up' if all else fails
  
//   // Animation variants based on direction
//   const variants = {
//     initial: (direction) => ({
//       y: direction === 'up' ? '100vh' : direction === 'down' ? '-100vh' : 0,
//       opacity: 0
//     }),
//     animate: {
//       y: 0,
//       opacity: 1,
//       transition: {
//         duration: 0.5,
//         ease: [0.22, 1, 0.36, 1]
//       }
//     },
//     exit: (direction) => ({
//       y: direction === 'up' ? '-100vh' : direction === 'down' ? '100vh' : 0,
//       opacity: 0,
//       transition: {
//         duration: 0.5,
//         ease: [0.22, 1, 0.36, 1]
//       }
//     })
//   };

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         width: '100%',
//         height: '100%',
//         overflow: 'hidden',
//         background: 'linear-gradient(180deg, #141118 0%, #0A0308 100%)'// This inherits background from parent
//       }}
//     >
//       <AnimatePresence mode="sync" initial={false}>
//         <motion.div
//           key={location.pathname}
//           custom={direction}
//           variants={variants}
//           initial="initial"
//           animate="animate"
//           exit="exit"
//           style={{ 
//             width: '100%', 
//             height: '100%', 
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             overflow: 'auto', // Changed from 'hidden' to 'auto' to allow scrolling
//             backgroundColor: 'linear-gradient(180deg, #141118 0%, #0A0308 100%)',
//             zIndex: 1,
//           }}
//         >
//           {children}
//         </motion.div>
//       </AnimatePresence>
//     </Box>
//   );
// };

// // This component needs to be used in your navigation components to set direction
// export const AnimatedNavLink = ({ to, children, direction, component, ...props }) => {
//   const navigate = useNavigate();
//   const { setNavDirection } = useNavigation();
  
//   const handleClick = (e) => {
//     if (props.onClick) {
//       props.onClick(e);
//     }
    
//     if (to) {
//       e.preventDefault();
//       setNavDirection(direction);
      
//       // Increase delay to ensure animation starts before navigation
//       setTimeout(() => {
//         navigate(to);
//       }, 50);
//     }
//   };
  
//   // If Link component is specified (for React Router), use that instead
//   if (component === Link) {
//     return (
//       <Link to={to} onClick={handleClick} {...props}>
//         {children}
//       </Link>
//     );
//   }
  
//   // If a component is specified, render it with props
//   if (component) {
//     const Component = component;
//     return (
//       <Component href={to} onClick={handleClick} {...props}>
//         {children}
//       </Component>
//     );
//   }
  
//   // Otherwise render a regular <a> tag
//   return (
//     <a href={to} onClick={handleClick} {...props}>
//       {children}
//     </a>
//   );
// };

// export default PageTransitionWrapper;

import React, { useContext, createContext, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Box } from '@mui/material';

const NavigationContext = createContext({
  previousPath: null,
  currentPath: null,
  navDirection: null,
  setNavDirection: () => {},
  navigationMap: {},
});

// This component will wrap your entire Routes component
export const NavigationProvider = ({ children, navigationMap = {} }) => {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState(null);
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [navDirection, setNavDirection] = useState(null); // 'up', 'down', or null

  useEffect(() => {
    if (location.pathname !== currentPath) {
      setPreviousPath(currentPath);
      setCurrentPath(location.pathname);
      
      // Reset direction after navigation is complete
      const timer = setTimeout(() => {
        setNavDirection(null);
      }, 1500); // Increased to allow for longer animations
      
      return () => clearTimeout(timer);
    }
  }, [location.pathname, currentPath]);

  const determineDefaultDirection = (prev, current) => {
    if (!prev) return null;
    
    // Get paths without query params for comparison
    const cleanPrev = prev.split('?')[0];
    const cleanCurrent = current.split('?')[0];
    
    return cleanPrev.localeCompare(cleanCurrent) < 0 ? 'up' : 'down';
  };

  return (
    <NavigationContext.Provider
      value={{
        previousPath,
        currentPath,
        navDirection,
        setNavDirection,
        navigationMap,
        determineDefaultDirection
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

// Hook to use the navigation context
export const useNavigation = () => useContext(NavigationContext);

// This component wraps each Route and applies the animations
const PageTransitionWrapper = ({ children }) => {
  const location = useLocation();
  const { 
    navDirection, 
    navigationMap, 
    previousPath, 
    determineDefaultDirection 
  } = useNavigation();
  
  // Determine direction based on navigation map or default logic
  const direction = navDirection || 
    (previousPath && navigationMap[previousPath]?.[location.pathname]) || 
    determineDefaultDirection(previousPath, location.pathname) || 
    'up'; // Default to 'up' if all else fails
  
  // Animation variants based on direction with improved smoothness
  const variants = {
    initial: (direction) => ({
      y: direction === 'up' ? '80vh' : direction === 'down' ? '-80vh' : 0,
      opacity: 0,
      scale: 0.95,
    }),
    animate: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 150,
        damping: 30,
        mass: 0.8,
        duration: 0.3,
        restDelta: 0.001
      }
    },
    exit: (direction) => ({
      y: direction === 'up' ? '-80vh' : direction === 'down' ? '80vh' : 0,
      opacity: 0,
      scale: 1.05,
      transition: {
        type: 'tween',
        ease: [0.25, 0.1, 0.25, 1], // Cubic bezier for smoother exit
        duration: 0.3,
      }
    })
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        background: 'linear-gradient(180deg, #141118 0%, #0A0308 100%)'
      }}
    >
      <AnimatePresence mode="sync" initial={false}>
        <motion.div
          key={location.pathname}
          custom={direction}
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          style={{ 
            width: '100%', 
            height: '100%', 
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'auto',
            background: 'linear-gradient(180deg, #141118 0%, #0A0308 100%)',
            zIndex: 1,
          }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

// This component needs to be used in your navigation components to set direction
export const AnimatedNavLink = ({ to, children, direction, component, ...props }) => {
  const navigate = useNavigate();
  const { setNavDirection } = useNavigation();
  
  const handleClick = (e) => {
    if (props.onClick) {
      props.onClick(e);
    }
    
    if (to) {
      e.preventDefault();
      setNavDirection(direction);
      
      // Increase delay to ensure animation starts before navigation
      setTimeout(() => {
        navigate(to);
      }, 70); // Slightly increased to ensure animation kicks in properly
    }
  };
  
  // If Link component is specified (for React Router), use that instead
  if (component === Link) {
    return (
      <Link to={to} onClick={handleClick} {...props}>
        {children}
      </Link>
    );
  }
  
  // If a component is specified, render it with props
  if (component) {
    const Component = component;
    return (
      <Component href={to} onClick={handleClick} {...props}>
        {children}
      </Component>
    );
  }
  
  // Otherwise render a regular <a> tag
  return (
    <a href={to} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default PageTransitionWrapper;